import React from "react";

type SetupLoadingScreenProps = {
  progress: number;
  message: string;
};

const SetupLoadingScreen = ({ progress, message }: SetupLoadingScreenProps) => {
  const safeProgress = Math.max(0, Math.min(100, Math.round(progress)));

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-amber-100 via-sky-100 to-rose-100 px-4 py-8">
      <div className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-3xl items-center justify-center">
        <div className="relative w-full overflow-hidden rounded-3xl border border-white/70 bg-white/90 p-8 text-center shadow-2xl backdrop-blur">
          <div className="relative mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-amber-200 to-pink-200 shadow-lg">
            <img
              src="/icons/icon-96x96.png"
              alt="TG Tots"
              className="h-12 w-12 object-contain"
            />
          </div>

          <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-indigo-700">
            Downloading Resources
          </h1>
          <p className="mt-2 text-base font-medium text-slate-600">
            {message}
          </p>

          <div className="mt-8">
            <div className="text-4xl font-extrabold text-indigo-600">
              {safeProgress}%
            </div>
            <div className="mt-4 h-4 w-full overflow-hidden rounded-full bg-slate-200 shadow-inner">
              <div
                className="setup-progress-bar h-full rounded-full bg-gradient-to-r from-indigo-500 via-sky-500 to-emerald-500"
                style={{ width: `${safeProgress}%` }}
              />
            </div>
            <div className="mt-3 h-5 text-sm font-semibold text-slate-500">
              {safeProgress < 100 ? "Please keep this tab open." : "Ready."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupLoadingScreen;
